import { useFormat } from '~/components/hooks/use-format'

export const buildPriceRangeTagMessage = (
  minNumber = 0,
  maxNumber = 0,
): string | undefined => {
  const { formatNumber } = useFormat()
  if (minNumber !== null && (maxNumber === null || maxNumber === 0)) {
    return `${formatNumber(minNumber)} and above`
  }
  return `${formatNumber(minNumber)} to ${formatNumber(maxNumber)}`
}
